<footer>
  <h2>Contact</h2>
  <ul>
    <li>
      <a
        href="https://www.linkedin.com/in/ato-koomson/"
        [style.--link-hover-color]="this.linkHoverColor"
        target="_blank"
        >LinkedIn</a
      >
    </li>
    <li>
      <a
        href="mailto:ato_koomson@hotmail.ca"
        [style.--link-hover-color]="this.linkHoverColor"
        target="_blank"
        >Email</a
      >
    </li>
    <li>
      <a
        href="https://github.com/flashato9"
        [style.--link-hover-color]="this.linkHoverColor"
        target="_blank"
        >Github</a
      >
    </li>
  </ul>
  <small>
    <span> Copyright &#xa9; 2026 Ato Koomson </span>
    <span> All Rights Reserved </span>
  </small>
</footer>
